import { render, staticRenderFns } from "./CourseTypePicker.vue?vue&type=template&id=4f772067&"
import script from "./CourseTypePicker.vue?vue&type=script&lang=js&"
export * from "./CourseTypePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports